import React from 'react';
import useHomeContext from 'Context/HomeContext';

export const nothing = 'nothing';

function isKeyComboPressed(ref) {
  const keys = ['MetaLeft', 'AltLeft', 'ShiftLeft'];

  return keys.reduce((acc, curr) => (acc && ref.current[curr]));
}

export default function useDebugPanel() {
  const { isDebugUser } = useHomeContext();
  const [view, setView] = React.useState(nothing);

  const keysPressedRef = React.useRef();

  const onKeydown = (evt) => {
    if (!isDebugUser) {
      return;
    }

    if (!keysPressedRef.current) {
      keysPressedRef.current = {
        [evt.code]: true,
      };
    } else {
      keysPressedRef.current[evt.code] = true;
    }

    setView((prevState) => {
      if (prevState === nothing && isKeyComboPressed(keysPressedRef)) {
        return 'button';
      }

      return prevState;
    });
  };

  const onKeyUp = (evt) => {
    if (!isDebugUser) {
      return;
    }

    if (!keysPressedRef.current) {
      return;
    }

    keysPressedRef.current[evt.code] = false;

    setView((prevState) => {
      if (prevState === 'button' && !isKeyComboPressed(keysPressedRef)) {
        return nothing;
      }

      return prevState;
    });
  };

  React.useEffect(() => {
    window.addEventListener('keydown', onKeydown);
    window.addEventListener('keyup', onKeyUp);

    return () => {
      window.removeEventListener('keydown', onKeydown);
      window.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  return {
    view,
    onClickButton: () => {
      setView('panel');
    },
    onClosePanel: () => {
      setView(nothing);
    },
    showing: view !== nothing,
  };
}
